import { render, staticRenderFns } from "./IntentAceessChart.vue?vue&type=template&id=99a84cf8&scoped=true"
import script from "./IntentAceessChart.vue?vue&type=script&lang=js"
export * from "./IntentAceessChart.vue?vue&type=script&lang=js"
import style0 from "./IntentAceessChart.vue?vue&type=style&index=0&id=99a84cf8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99a84cf8",
  null
  
)

export default component.exports